import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  AppBar,
  Paper,
  Tooltip,
  Typography,
  Toolbar,
} from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditPurpose = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const location = useLocation();
  const navigate = useNavigate();
  const { id: purposeId } = useParams();

  const { purposeName } = location.state || {};
  const [editedPurpose, setEditedPurpose] = useState(purposeName || '');
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem('token');

  const handleUpdate = async () => {
    if (!editedPurpose.trim()) {
      setSnackbarMessage('Purpose name cannot be empty.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }
    if (!purposeId) {
      setSnackbarMessage('Purpose ID is missing.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }

    const payload = {
      purpose: editedPurpose,
    };

    try {
      const token = sessionStorage.getItem('token');

      const response = await fetch(`${apiUrl}/Enquiry/UpdatePurpose/${purposeId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      const message = (data && (data.msg || data.message)) || 'Purpose has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('Error updating purpose:', error);
      setSnackbarMessage('An error occurred while updating the purpose.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Purpose
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <Box>
          <TextField
            label="Purpose Name"
            variant="outlined"
            fullWidth
            value={editedPurpose}
            onChange={(e) => setEditedPurpose(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!editedPurpose && "Enter Purpose Name"} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                sx={{ mr: 2 }}
                disabled={!editedPurpose}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={() => navigate(-1)}
          >
            CANCEL
          </Button>
        </Box>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Purpose Updated ✅'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Purpose has been updated successfully.')}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditPurpose;
